"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabbedEditor = TabbedEditor;
exports.default = createTabbedEditor;
exports.UpdateOptionsStrategy = void 0;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tabs = _interopRequireDefault(require("antd/lib/tabs"));

var _propTypes2 = require("../../../visualizations/prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UpdateOptionsStrategy = {
  replace: (existingOptions, newOptions) => (0, _lodash.merge)({}, newOptions),
  shallowMerge: (existingOptions, newOptions) => (0, _lodash.extend)({}, existingOptions, newOptions),
  deepMerge: (existingOptions, newOptions) => (0, _lodash.merge)({}, existingOptions, newOptions)
};
exports.UpdateOptionsStrategy = UpdateOptionsStrategy;

function TabbedEditor(_ref) {
  var tabs = _ref.tabs,
      options = _ref.options,
      data = _ref.data,
      onOptionsChange = _ref.onOptionsChange,
      restProps = _objectWithoutProperties(_ref, ["tabs", "options", "data", "onOptionsChange"]);

  var optionsChanged = function optionsChanged(newOptions) {
    var updateStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UpdateOptionsStrategy.deepMerge;
    onOptionsChange(updateStrategy(options, newOptions));
  };

  tabs = (0, _lodash.filter)(tabs, tab => (0, _lodash.isFunction)(tab.isAvailable) ? tab.isAvailable(options, data) : true);
  return /*#__PURE__*/_react.default.createElement(_tabs.default, {
    animated: false,
    tabBarGutter: 0
  }, (0, _lodash.map)(tabs, (_ref2) => {
    var key = _ref2.key,
        title = _ref2.title,
        Component = _ref2.component;
    return /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      key: key,
      tab: /*#__PURE__*/_react.default.createElement("span", {
        "data-test": "VisualizationEditor.Tabs.".concat(key)
      }, title)
    }, /*#__PURE__*/_react.default.createElement(Component, _extends({
      options: options,
      data: data,
      onOptionsChange: optionsChanged
    }, restProps)));
  }));
}

TabbedEditor.propTypes = _objectSpread({}, _propTypes2.EditorPropTypes, {
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    isAvailable: _propTypes.default.func,
    // (options) => boolean
    component: _propTypes.default.func.isRequired
  }))
});
TabbedEditor.defaultProps = {
  tabs: []
};

function createTabbedEditor(tabs) {
  return function TabbedEditorWrapper(props) {
    return /*#__PURE__*/_react.default.createElement(TabbedEditor, _extends({}, props, {
      tabs: tabs
    }));
  };
}
//# sourceMappingURL=createTabbedEditor.js.map